import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { IntegrationCreate } from './IntegrationCreate';
import { IntegrationOverview } from './IntegrationOverview';
import { IntegrationCredentialsModal } from './IntegrationCredentialsModal';
import { API_ACCESS_PATH, IntegrationCredentials } from './integrationUtils';
import { apiClientService } from '@api/services/services';
import { ApiScopeDto } from '@api/models/apiClient/ApiScopeDto';
import { ApiClientDetailDto } from '@api/models/apiClient/ApiClientDetailDto';

export const IntegrationDetail: FC = () => {
  const { apiClientId } = useParams();
  const navigate = useNavigate();
  const [scopeCatalogue, setScopeCatalogue] = useState<ApiScopeDto[]>([]);
  //Lives here, above both views, so it survives the switch from .../new to the created client's detail.
  const [credentials, setCredentials] = useState<IntegrationCredentials>();

  useEffect(() => {
    apiClientService.getScopes().then((res) => setScopeCatalogue(res.data));
  }, []);

  const handleCreated = (detail: ApiClientDetailDto) => {
    setCredentials({
      clientName: detail.name,
      clientId: detail.clientId,
      kid: detail.keys[0].kid,
      tokenEndpoint: detail.tokenEndpoint,
      apiBase: detail.apiBase,
      docsUrl: detail.docsUrl,
      apiKey: detail.keys[0].apiKey ?? undefined,
    });
    navigate(`${API_ACCESS_PATH}/${detail.id}`, { replace: true });
  };

  return (
    <>
      {credentials && <IntegrationCredentialsModal credentials={credentials} onClose={() => setCredentials(undefined)} />}
      {apiClientId === 'new' ? (
        <IntegrationCreate scopeCatalogue={scopeCatalogue} onCreated={handleCreated} />
      ) : (
        <IntegrationOverview apiClientId={apiClientId!} scopeCatalogue={scopeCatalogue} onCredentialsIssued={setCredentials} />
      )}
    </>
  );
};
